import SemaphoreHelper from '../../../helpers/semaphore-helper';
import { OfflineStorageObject } from './offline-storage-object';
import { OfflineStorageTimestampService } from '../../offline-storage-timestamp.service';
import { NgForage } from 'ngforage';
import { AbstractOfflineStorageService } from './abstract-offline-storage-service';
import { CollectionHelper } from '../../../helpers/collection-helper';
import { EXPIRED_OFFLINE_ITEM_REMOVAL_INTERVAL } from '../../../../globals/globals';

// TODO replace all usages of this class by ExpiredOfflineObjectAsyncTimestampRemover
export abstract class ExpiredOfflineObjectRemover<
  ID,
  O extends OfflineStorageObject<ID>
> {
  constructor(
    private offlineStorageService: AbstractOfflineStorageService<
      ID,
      O,
      ExpiredOfflineObjectRemover<ID, O>
    >,
    private offlineStorageTimestampService: OfflineStorageTimestampService,
    private ngForage: NgForage
  ) {}

  removeExpiredItems(): void {
    SemaphoreHelper.use(
      this.offlineStorageService.offlineStorageMutex,
      async () => {
        const expiredItems = this.offlineStorageTimestampService.getExpiredItems(
          this.offlineStorageService.timestampCollectionKey
        );
        if (CollectionHelper.isPopulated(expiredItems)) {
          const promises = expiredItems.map(async i => {
            const storageKey = this.offlineStorageService.getObjectStorageKey(
              this.offlineStorageService.convertToID(i.key)
            );
            const expiredItem = await this.ngForage.getItem<O>(storageKey);
            if (expiredItem != null) {
              await this.offlineStorageService.cleanupOfflineObject(
                expiredItem
              );
            }
            await this.ngForage.removeItem(storageKey);
          });
          try {
            await Promise.all(promises);
          } catch (err) {
            console.error(err);
          }
          this.offlineStorageTimestampService.removeItems(
            this.offlineStorageService.timestampCollectionKey,
            expiredItems.map(i => i.key)
          );
        }
        setTimeout(
          () => this.removeExpiredItems(),
          EXPIRED_OFFLINE_ITEM_REMOVAL_INTERVAL
        );
      }
    );
  }
}
